export default __webpack_public_path__ + "static/media/Live-documentation.6c283529.md";